import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.boundToggle = this.toggle.bind(this);
    document.addEventListener('toggle-contract-filters', this.boundToggle);
  }

  disconnect() {
    document.removeEventListener('toggle-contract-filters', this.boundToggle);
  }

  toggle() {
    const el = this.element;
    el.style.display = (el.style.display === 'none') ? 'block' : 'none';
  }
}
